var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTableImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 3,
    fill: "#DA2929"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.73379,
    cy: 3.73336,
    r: 1.6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.00039,
    cy: 8.00002,
    r: 1.6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.267,
    cy: 12.2667,
    r: 1.6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.267,
    cy: 3.73336,
    r: 1.6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.73379,
    cy: 12.2667,
    r: 1.6,
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableImg);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgb3BhY2l0eT0iMC41Ij4KPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiByeD0iMyIgZmlsbD0iI0RBMjkyOSIvPgo8Y2lyY2xlIGN4PSIzLjczMzc5IiBjeT0iMy43MzMzNiIgcj0iMS42IiBmaWxsPSJ3aGl0ZSIvPgo8Y2lyY2xlIGN4PSI4LjAwMDM5IiBjeT0iOC4wMDAwMiIgcj0iMS42IiBmaWxsPSJ3aGl0ZSIvPgo8Y2lyY2xlIGN4PSIxMi4yNjciIGN5PSIxMi4yNjY3IiByPSIxLjYiIGZpbGw9IndoaXRlIi8+CjxjaXJjbGUgY3g9IjEyLjI2NyIgY3k9IjMuNzMzMzYiIHI9IjEuNiIgZmlsbD0id2hpdGUiLz4KPGNpcmNsZSBjeD0iMy43MzM3OSIgY3k9IjEyLjI2NjciIHI9IjEuNiIgZmlsbD0id2hpdGUiLz4KPC9nPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };